<template>
  <div class="modal fade show d-block custom-modal" id="ValidateInvoiceModal" tabindex="-1" role="dialog">
    <div class="modal-dialog" style="width: 1250px" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ $t('modal.validateModal.title') }}</h5>
          <button type="button" class="btn-close" @click="$emit('close')" aria-label="Close"></button>
        </div>

        <div class="px-3 pt-3 pb-2 border-bottom">
          <div class="row g-2 align-items-center">
            <div class="col-auto fw-semibold">{{ $t('modal.validateModal.validatorMode') }}</div>
            <div class="col-auto">
              <select
                  class="form-select form-select-sm"
                  data-testid="validator-mode-select"
                  v-model="localValidatorMode"
                  @change="handleValidatorModeChanged"
              >
                <option
                    v-for="mode in validatorOptions"
                    :key="mode"
                    :value="mode"
                >
                  {{ modeLabel(mode) }}
                </option>
              </select>
            </div>
            <div class="col-auto">
              <button
                  type="button"
                  class="btn btn-outline-primary btn-sm"
                  data-testid="validate-again-button"
                  @click="$emit('validate-with-mode', localValidatorMode)"
              >
                {{ $t('modal.validateModal.validateNow') }}
              </button>
            </div>
            <div class="col small text-muted">
              {{ $t('modal.validateModal.requestedMode') }}: <strong>{{ validationMetadata.requestedMode || '-' }}</strong>
              |
              {{ $t('modal.validateModal.usedMode') }}: <strong>{{ validationMetadata.usedMode || '-' }}</strong>
              |
              {{ $t('modal.validateModal.usedProvider') }}: <strong>{{ validationMetadata.usedProvider || '-' }}</strong>
              <span v-if="validationMetadata.fallbackUsed" class="ms-2 text-warning fw-semibold">
                ({{ $t('modal.validateModal.fallbackUsed') }})
              </span>
            </div>
          </div>
        </div>

        <div class="modal-body p-0" style="height:78vh;">
          <iframe ref="invoiceIframe" data-testid="validation-report-iframe" class="w-100 h-100 border-0 ps-2"></iframe>
        </div>

        <div class="modal-footer">
          <button
              type="button"
              class="btn btn-primary"
              data-testid="validate-now-button"
              @click="$emit('validate-with-mode', localValidatorMode)"
          >
            {{ $t('modal.validateModal.validateNow') }}
          </button>
          <button type="button" class="btn btn-secondary" @click="$emit('close')">
            {{ $t('modal.validateModal.close') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    validationResultHtml: {
      type: String,
      default: ''
    },
    validatorMode: {
      type: String,
      default: 'kositdaemon'
    },
    validatorOptions: {
      type: Array,
      default: () => ['kositdaemon', 'servicebw', 'internal', 'auto']
    },
    validationMetadata: {
      type: Object,
      default: () => ({
        requestedMode: '',
        usedMode: '',
        usedProvider: '',
        fallbackUsed: false
      })
    }
  },
  data() {
    return {
      localValidatorMode: this.validatorMode || 'kositdaemon'
    };
  },
  watch: {
    validationResultHtml(newHtml) {
      this.renderHtmlToIframe(newHtml);
    },
    validatorMode(newMode) {
      this.localValidatorMode = newMode || 'kositdaemon';
    }
  },
  mounted() {
    if (this.validationResultHtml) {
      this.renderHtmlToIframe(this.validationResultHtml);
    }
  },
  methods: {
    handleValidatorModeChanged() {
      this.$emit('validator-mode-changed', this.localValidatorMode);
    },
    modeLabel(mode) {
      const normalizedMode = String(mode || '').toLowerCase();
      switch (normalizedMode) {
        case 'kositdaemon':
        case 'kosit-daemon':
        case 'kosit':
          return this.$t('modal.validateModal.modeKositDaemon');
        case 'servicebw':
        case 'service-bw':
          return this.$t('modal.validateModal.modeServiceBw');
        case 'internal':
          return this.$t('modal.validateModal.modeInternal');
        case 'auto':
          return this.$t('modal.validateModal.modeAuto');
        default:
          return mode;
      }
    },
    renderHtmlToIframe(htmlContent) {
      const iframe = this.$refs.invoiceIframe;
      if (!iframe) return;

      const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
      iframeDoc.open();
      iframeDoc.write(htmlContent);
      iframeDoc.close();
    }
  }
}
</script>
<style scoped>
.custom-modal .modal-dialog {
  display: inline-block;
  width: auto;
  max-width: none;
}

.custom-modal .modal-content {
  width: auto;
  overflow: visible;
}
</style>
